import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Typography } from '@mui/material';
import DashboardSearchBarAdmin from './DashboardSearchBar';
import EventsListAdmin from './EventList';
import { Layout, Loading, UserNavbar } from '../../../../../../components';

function SearchEvents() {
  const { filteredEvents, loading } = useSelector((store) => store.events);

  const getPageHeaderTitle = () => {
    if (filteredEvents?.length) return 'We found these events!';

    return '';
  };

  const getPageContent = () => {
    if (filteredEvents?.length) return <EventsListAdmin events={filteredEvents} />;
    return null;
  };

  return (
    <Layout>
      {loading && <Loading />}
      <UserNavbar />
      <Box
        pt={15}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center">
        <DashboardSearchBarAdmin />
      </Box>
      <Grid container>
        <Grid item xs={12} textAlign="center">
          <Typography variant="h4" color="#EE7B57" fontWeight="bold" marginTop={4}>
            {getPageHeaderTitle()}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {getPageContent()}
        </Grid>
      </Grid>
    </Layout>
  );
}

export default SearchEvents;
